import { delay } from '../delay';
import assign from 'object-assign';
import { DateTime } from 'luxon';
import _ from 'lodash';
import KanbanFunctions from './kanban-functions';
import { SetupInstance } from '../../app/msal-account-helpers';
import ObjectID from 'bson-objectid';
import { arrayAny } from '../../utils/arrayUtils';

// This file mocks a web API by working with the hard-coded data below.
// It uses setTimeout to simulate the delay of an AJAX call.
// All calls return promises.

/*

    <a href="#/" className="dropdown-item"><i className="far fa-folder fa-fw fa-lg text-gray-500 me-1"></i> 55WHIP/New Deal</a>
    <a href="#/" className="dropdown-item"><i className="far fa-folder fa-fw fa-lg text-gray-500 me-1"></i> Maintenance/RAG</a>
    <a href="#/" className="dropdown-item"><i className="far fa-folder fa-fw fa-lg text-gray-500 me-1"></i> Tenants/New Tenants</a>
    <a href="#/" className="dropdown-item"><i className="far fa-folder fa-fw fa-lg text-gray-500 me-1"></i> Tenants/Move</a>
    <a href="#/" className="dropdown-item"><i className="far fa-folder fa-fw fa-lg text-gray-500 me-1"></i> Compliance/Regular Checks</a>
    <a href="#/" className="dropdown-item"><i className="far fa-plus fa-fw fa-lg text-gray-500 me-1"></i> ... Add New Board ...</a>


*/

class KanbanAPI {

    constructor(instance, inProgress, accounts, forceRefresh) {

        this.instance = SetupInstance(instance);
        this.inProgress = inProgress;
        this.account = accounts[0];
    }

    static listeners = [];

    static checkStatuses = [
        { status: "N/A", value: 0 },
        { status: "Passed", value: 1 },
        { status: "Failed", value: 2 }
    ];

    static projects = [
        {
            "companyId": "66d74be9d236cf062d9664f2",
            "propertyId": "property-22BEL",
            "name": "22BEL",
            "columns": [
                {
                    "columnId": "maint-todo",
                    "displayOrder": 0,
                    "name": "To Do",
                    "itemClasses": null,
                    "items": [
                        {
                            "name": "Fix Leaking Kitchen Tap",
                            "description": "Kitchen tap in unit 2A is dripping constantly, needs immediate repair",
                            "order": 0,
                            "boardId": "659d337db5cf709deb2e3b2b",
                            "columnId": "maint-todo",
                            "subTasks": [],
                            "tags": ["maintenance", "plumbing", "urgent"],
                            "templateId": "66e2ee5bf854ca6e1ba1bade",
                            "completedBy": null,
                            "dueDate": null,
                            "completed": null,
                            "destinationColumnId": null,
                            "status": "Open",
                            "priority": "High",
                            "id": "maintenance001",
                            "created": "2024-01-15T10:30:00.000Z",
                            "modified": "2024-01-15T10:30:00.000Z"
                        }
                    ]
                },
                {
                    "columnId": "maint-progress",
                    "displayOrder": 1,
                    "name": "In Progress",
                    "itemClasses": null,
                    "items": [
                        {
                            "name": "Heating System Repair",
                            "description": "Boiler in unit 1B not working properly, tenants reporting no hot water",
                            "order": 0,
                            "boardId": "659d337db5cf709deb2e3b2b",
                            "columnId": "maint-progress",
                            "subTasks": [],
                            "tags": ["maintenance", "heating", "critical"],
                            "templateId": "66e2ee5bf854ca6e1ba1bade",
                            "completedBy": null,
                            "dueDate": null,
                            "completed": null,
                            "destinationColumnId": null,
                            "status": "In Progress",
                            "priority": "Critical",
                            "id": "maintenance002",
                            "created": "2024-01-10T09:15:00.000Z",
                            "modified": "2024-01-10T09:15:00.000Z"
                        }
                    ]
                },
                {
                    "columnId": "maint-done",
                    "displayOrder": 2,
                    "name": "Done",
                    "itemClasses": null,
                    "items": [
                        {
                            "name": "Annual HVAC Service",
                            "description": "Completed annual maintenance service for HVAC system",
                            "order": 0,
                            "boardId": "659d337db5cf709deb2e3b2b",
                            "columnId": "maint-done",
                            "subTasks": [],
                            "tags": ["maintenance", "hvac", "annual"],
                            "templateId": "66e2ee5bf854ca6e1ba1bade",
                            "completedBy": null,
                            "dueDate": null,
                            "completed": "2023-12-01T14:30:00.000Z",
                            "destinationColumnId": null,
                            "status": "Closed",
                            "priority": "Medium",
                            "id": "maintenance003",
                            "created": "2023-11-15T08:00:00.000Z",
                            "modified": "2023-12-01T14:30:00.000Z"
                        }
                    ]
                }
            ],
            "id": "659d337db5cf709deb2e3b2b",
            "created": "2024-01-01T00:00:00.000Z",
            "modified": "2024-01-15T10:30:00.000Z"
        },
        {
            "companyId": "66d74be9d236cf062d9664f2",
            "propertyId": null,
            "name": "Property Management System",
            "columns": [
                {
                    "columnId": "66e2ee6df854ca6e1ba1bb05",
                    "displayOrder": 0,
                    "name": "To Do",
                    "itemClasses": null,
                    "items": [
                        {
                            "name": "Users - Set Roles",
                            "description": "Dont want to use Azure Portal to set user roles - manage these through the system.",
                            "order": 0,
                            "boardId": "66e2ee6df854ca6e1ba1bb03",
                            "columnId": "66e2ee6df854ca6e1ba1bb05",
                            "subTasks": [],
                            "tags": [],
                            "templateId": "66e2ee5bf854ca6e1ba1bade",
                            "completedBy": null,
                            "dueDate": null,
                            "completed": null,
                            "destinationColumnId": null,
                            "status": "Open",
                            "priority": "Medium",
                            "template": {
                                "templateName": "None",
                                "default": true,
                                "subTasks": [],
                                "isInspection": false,
                                "id": "66e2ee5bf854ca6e1ba1bade",
                                "createdBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                },
                                "created": "2024-09-12T13:36:27.444Z",
                                "modified": "2024-09-12T13:36:27.444Z",
                                "modifiedBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                }
                            },
                            "id": "66e318a1906f69c5c9deb080",
                            "createdBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            },
                            "created": "2024-09-12T16:36:50.221Z",
                            "modified": "2024-09-16T16:45:04.391Z",
                            "modifiedBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            }
                        },
                        {
                            "name": "On Kanban screen change buttons to a group with drop down to make it look more elegant",
                            "description": "",
                            "order": 1,
                            "boardId": "66e2ee6df854ca6e1ba1bb03",
                            "columnId": "66e2ee6df854ca6e1ba1bb05",
                            "subTasks": [],
                            "tags": [],
                            "templateId": "66e2ee5bf854ca6e1ba1bade",
                            "completedBy": null,
                            "dueDate": null,
                            "completed": null,
                            "destinationColumnId": null,
                            "status": "Open",
                            "priority": "Low",
                            "template": {
                                "templateName": "None",
                                "default": true,
                                "subTasks": [],
                                "isInspection": false,
                                "id": "66e2ee5bf854ca6e1ba1bade",
                                "createdBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                },
                                "created": "2024-09-12T13:36:27.444Z",
                                "modified": "2024-09-12T13:36:27.444Z",
                                "modifiedBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                }
                            },
                            "id": "66e6902747145d05289ce0d1",
                            "createdBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            },
                            "created": "2024-09-15T07:43:35.612Z",
                            "modified": "2024-09-16T16:45:04.391Z",
                            "modifiedBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            }
                        },
                        {
                            "name": "Hook up Kanban board to SignalR",
                            "description": "",
                            "order": 2,
                            "boardId": "66e2ee6df854ca6e1ba1bb03",
                            "columnId": "66e2ee6df854ca6e1ba1bb05",
                            "subTasks": [],
                            "tags": [],
                            "templateId": "66e2ee5bf854ca6e1ba1bade",
                            "completedBy": null,
                            "dueDate": null,
                            "completed": null,
                            "destinationColumnId": null,
                            "status": "Open",
                            "priority": "High",
                            "template": {
                                "templateName": "None",
                                "default": true,
                                "subTasks": [],
                                "isInspection": false,
                                "id": "66e2ee5bf854ca6e1ba1bade",
                                "createdBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                },
                                "created": "2024-09-12T13:36:27.444Z",
                                "modified": "2024-09-12T13:36:27.444Z",
                                "modifiedBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                }
                            },
                            "id": "66e6909e47145d05289ce0d2",
                            "createdBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            },
                            "created": "2024-09-15T07:45:34.328Z",
                            "modified": "2024-09-16T16:45:04.391Z",
                            "modifiedBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            }
                        },
                        {
                            "name": "Create / Manage Companies",
                            "description": "Sys Admins need the ability to create and manage companies. Certain aspects of the company maybe suitable for editing by the customer administrators ",
                            "order": 3,
                            "boardId": "66e2ee6df854ca6e1ba1bb03",
                            "columnId": "66e2ee6df854ca6e1ba1bb05",
                            "subTasks": [],
                            "tags": [],
                            "templateId": "66e2ee5bf854ca6e1ba1bade",
                            "completedBy": null,
                            "dueDate": null,
                            "completed": null,
                            "destinationColumnId": null,
                            "status": "Open",
                            "priority": "Medium",
                            "template": {
                                "templateName": "None",
                                "default": true,
                                "subTasks": [],
                                "isInspection": false,
                                "id": "66e2ee5bf854ca6e1ba1bade",
                                "createdBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                },
                                "created": "2024-09-12T13:36:27.444Z",
                                "modified": "2024-09-12T13:36:27.444Z",
                                "modifiedBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                }
                            },
                            "id": "66e3185c906f69c5c9deb07f",
                            "createdBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            },
                            "created": "2024-09-12T16:35:40.614Z",
                            "modified": "2024-09-16T16:45:04.391Z",
                            "modifiedBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            }
                        },
                        {
                            "name": "Xero Integration",
                            "description": "We want to see the feed of Xero transactions to reconcile rent payments for tenants. Can reconcile in the system and Xero. Only interested in tenancy related transactions involving tenants. Not cleaning/maintenance. We are not replacing Xero UI with our own...",
                            "order": 4,
                            "boardId": "66e2ee6df854ca6e1ba1bb03",
                            "columnId": "66e2ee6df854ca6e1ba1bb05",
                            "subTasks": [],
                            "tags": [],
                            "templateId": "66e2ee5bf854ca6e1ba1bade",
                            "completedBy": null,
                            "dueDate": null,
                            "completed": null,
                            "destinationColumnId": null,
                            "status": "Open",
                            "priority": "Low",
                            "template": {
                                "templateName": "None",
                                "default": true,
                                "subTasks": [],
                                "isInspection": false,
                                "id": "66e2ee5bf854ca6e1ba1bade",
                                "createdBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                },
                                "created": "2024-09-12T13:36:27.444Z",
                                "modified": "2024-09-12T13:36:27.444Z",
                                "modifiedBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                }
                            },
                            "id": "66e6920947145d05289ce0d9",
                            "createdBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            },
                            "created": "2024-09-15T07:51:37.893Z",
                            "modified": "2024-09-16T16:45:04.391Z",
                            "modifiedBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            }
                        }
                    ]
                },
                {
                    "columnId": "66e2ee6df854ca6e1ba1bb07",
                    "displayOrder": 1,
                    "name": "In Progress",
                    "itemClasses": null,
                    "items": [
                        {
                            "name": "Bug - can't edit description after initial creation. Check title too.",
                            "description": "Can you edit the description? You can... is it a bit buggy???\n\nThe save button seems laggy",
                            "order": 0,
                            "boardId": "66e2ee6df854ca6e1ba1bb03",
                            "columnId": "66e2ee6df854ca6e1ba1bb07",
                            "subTasks": [],
                            "tags": [],
                            "templateId": "66e2ee5bf854ca6e1ba1bade",
                            "completedBy": null,
                            "dueDate": null,
                            "completed": null,
                            "destinationColumnId": null,
                            "status": "In Progress",
                            "priority": "Critical",
                            "template": {
                                "templateName": "None",
                                "default": true,
                                "subTasks": [],
                                "isInspection": false,
                                "id": "66e2ee5bf854ca6e1ba1bade",
                                "createdBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                },
                                "created": "2024-09-12T13:36:27.444Z",
                                "modified": "2024-09-12T13:36:27.444Z",
                                "modifiedBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                }
                            },
                            "id": "66e69506efb655f944d3518f",
                            "createdBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            },
                            "created": "2024-09-15T08:04:22.369Z",
                            "modified": "2024-09-17T13:18:28.553Z",
                            "modifiedBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            }
                        }
                    ]
                },
                {
                    "columnId": "66e2ee6df854ca6e1ba1bb09",
                    "displayOrder": 2,
                    "name": "Done",
                    "itemClasses": null,
                    "items": [
                        {
                            "name": "Allow deletion of tasks",
                            "description": "",
                            "order": 0,
                            "boardId": "66e2ee6df854ca6e1ba1bb03",
                            "columnId": "66e2ee6df854ca6e1ba1bb09",
                            "subTasks": [
                                {
                                    "subTaskId": "66e98169b2fad57bc2838a94",
                                    "title": "Select items for deletion",
                                    "order": 7,
                                    "isCompleted": true,
                                    "autoComplete": false,
                                    "templateItem": false,
                                    "checkCompleteStatus": "na"
                                }
                            ],
                            "tags": [],
                            "templateId": "66e2ee5bf854ca6e1ba1bade",
                            "completedBy": null,
                            "dueDate": null,
                            "completed": null,
                            "destinationColumnId": null,
                            "status": "Closed",
                            "priority": "High",
                            "template": {
                                "templateName": "None",
                                "default": true,
                                "subTasks": [],
                                "isInspection": false,
                                "id": "66e2ee5bf854ca6e1ba1bade",
                                "createdBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                },
                                "created": "2024-09-12T13:36:27.444Z",
                                "modified": "2024-09-12T13:36:27.444Z",
                                "modifiedBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                }
                            },
                            "id": "66e3179c906f69c5c9deb07d",
                            "createdBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            },
                            "created": "2024-09-12T16:32:28.589Z",
                            "modified": "2024-09-17T13:19:40.505Z",
                            "modifiedBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            }
                        },
                        {
                            "name": "On kanban board add sub tasks",
                            "description": "At the moment adding subtasks via user interface doesn't persist. It seems subtasks added via templates do...",
                            "order": 1,
                            "boardId": "66e2ee6df854ca6e1ba1bb03",
                            "columnId": "66e2ee6df854ca6e1ba1bb09",
                            "subTasks": [],
                            "tags": [],
                            "templateId": "66e2ee5bf854ca6e1ba1bade",
                            "completedBy": null,
                            "dueDate": null,
                            "completed": null,
                            "destinationColumnId": null,
                            "status": "Closed",
                            "priority": "Medium",
                            "template": {
                                "templateName": "None",
                                "default": true,
                                "subTasks": [],
                                "isInspection": false,
                                "id": "66e2ee5bf854ca6e1ba1bade",
                                "createdBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                },
                                "created": "2024-09-12T13:36:27.444Z",
                                "modified": "2024-09-12T13:36:27.444Z",
                                "modifiedBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                }
                            },
                            "id": "66e6934417e8f823ba0745eb",
                            "createdBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            },
                            "created": "2024-09-15T07:56:52.332Z",
                            "modified": "2024-09-17T13:19:40.505Z",
                            "modifiedBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            }
                        },
                        {
                            "name": "Bug - tiles with subtasks don't seem to be persisted after initial creation",
                            "description": "",
                            "order": 2,
                            "boardId": "66e2ee6df854ca6e1ba1bb03",
                            "columnId": "66e2ee6df854ca6e1ba1bb09",
                            "subTasks": [],
                            "tags": [],
                            "templateId": "66e2ee5bf854ca6e1ba1bade",
                            "completedBy": null,
                            "dueDate": null,
                            "completed": null,
                            "destinationColumnId": null,
                            "status": "Closed",
                            "priority": "Critical",
                            "template": {
                                "templateName": "None",
                                "default": true,
                                "subTasks": [],
                                "isInspection": false,
                                "id": "66e2ee5bf854ca6e1ba1bade",
                                "createdBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                },
                                "created": "2024-09-12T13:36:27.444Z",
                                "modified": "2024-09-12T13:36:27.444Z",
                                "modifiedBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                }
                            },
                            "id": "66e694ccefb655f944d3518e",
                            "createdBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            },
                            "created": "2024-09-15T08:03:24.256Z",
                            "modified": "2024-09-17T13:19:40.505Z",
                            "modifiedBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            }
                        },
                        {
                            "name": "Allow addition of columns",
                            "description": "Kanban boards can have more than 3 columns. Could maybe have less... The auto task templates feature may struggle to cope with boards with numbers of columns other than 3",
                            "order": 3,
                            "boardId": "66e2ee6df854ca6e1ba1bb03",
                            "columnId": "66e2ee6df854ca6e1ba1bb09",
                            "subTasks": [],
                            "tags": [],
                            "templateId": "66e2ee5bf854ca6e1ba1bade",
                            "completedBy": null,
                            "dueDate": null,
                            "completed": null,
                            "destinationColumnId": null,
                            "status": "Closed",
                            "priority": "Low",
                            "template": {
                                "templateName": "None",
                                "default": true,
                                "subTasks": [],
                                "isInspection": false,
                                "id": "66e2ee5bf854ca6e1ba1bade",
                                "createdBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                },
                                "created": "2024-09-12T13:36:27.444Z",
                                "modified": "2024-09-12T13:36:27.444Z",
                                "modifiedBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                }
                            },
                            "id": "66e317f5906f69c5c9deb07e",
                            "createdBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            },
                            "created": "2024-09-12T16:33:57.977Z",
                            "modified": "2024-09-17T13:19:40.505Z",
                            "modifiedBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            }
                        },
                        {
                            "name": "Allow Re-ordering of Columns",
                            "description": "",
                            "order": 4,
                            "boardId": "66e2ee6df854ca6e1ba1bb03",
                            "columnId": "66e2ee6df854ca6e1ba1bb09",
                            "subTasks": [],
                            "tags": [],
                            "templateId": "66e2ee5bf854ca6e1ba1bade",
                            "completedBy": null,
                            "dueDate": null,
                            "completed": null,
                            "destinationColumnId": null,
                            "status": "Closed",
                            "priority": "Medium",
                            "template": {
                                "templateName": "None",
                                "default": true,
                                "subTasks": [],
                                "isInspection": false,
                                "id": "66e2ee5bf854ca6e1ba1bade",
                                "createdBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                },
                                "created": "2024-09-12T13:36:27.444Z",
                                "modified": "2024-09-12T13:36:27.444Z",
                                "modifiedBy": {
                                    "userName": "System",
                                    "displayName": "System Service Account",
                                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                                    "apiRoles": [
                                        "systemAdmin"
                                    ],
                                    "companyName": "System",
                                    "emailAddress": "not_real@property-manager.com",
                                    "telegramChatId": 0,
                                    "phoneNumber": null,
                                    "unsocialHours": {
                                        "doNotDuringRanges": []
                                    },
                                    "suppressAllNotifications": false,
                                    "profileImage": null,
                                    "profileImageIncludingSasToken": null,
                                    "thumbnailProfileImage": null,
                                    "thumbnailProfileImageIncludingSasToken": null,
                                    "locale": "en-gb",
                                    "jobTitle": null,
                                    "invitePending": false,
                                    "givenName": null,
                                    "surname": null
                                }
                            },
                            "id": "66e31789906f69c5c9deb07c",
                            "createdBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            },
                            "created": "2024-09-12T16:32:10.12Z",
                            "modified": "2024-09-17T13:19:40.505Z",
                            "modifiedBy": {
                                "userName": "ian.danger.robertson@gmail.com",
                                "displayName": "Ian Robertson",
                                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                                "apiRoles": [
                                    "tenant_Manager",
                                    "application_Developer",
                                    "user_Basic",
                                    "billing_Admin"
                                ],
                                "companyName": "Russet Properties (Software) Ltd",
                                "emailAddress": "ian.danger.robertson@gmail.com",
                                "telegramChatId": 5694353874,
                                "phoneNumber": "07530086434",
                                "unsocialHours": {
                                    "doNotDuringRanges": [
                                        {
                                            "days": [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ],
                                            "start": "20:00:00",
                                            "end": "09:30:00"
                                        },
                                        {
                                            "days": [
                                                5,
                                                6
                                            ],
                                            "start": "00:00:00",
                                            "end": "23:59:59"
                                        }
                                    ]
                                },
                                "suppressAllNotifications": false,
                                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                                "profileImageIncludingSasToken": null,
                                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                                "thumbnailProfileImageIncludingSasToken": null,
                                "locale": "en-gb",
                                "jobTitle": "System Architect",
                                "invitePending": false,
                                "givenName": "Ian",
                                "surname": "Robertson"
                            }
                        }
                    ]
                }
            ],
            "id": "66e2ee6df854ca6e1ba1bb03",
            "createdBy": {
                "userName": "ian.danger.robertson@gmail.com",
                "displayName": "Ian Robertson",
                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                "apiRoles": [
                    "tenant_Manager",
                    "application_Developer",
                    "user_Basic",
                    "billing_Admin"
                ],
                "companyName": "Russet Properties (Software) Ltd",
                "emailAddress": "ian.danger.robertson@gmail.com",
                "telegramChatId": 5694353874,
                "phoneNumber": "07530086434",
                "unsocialHours": {
                    "doNotDuringRanges": [
                        {
                            "days": [
                                0,
                                1,
                                2,
                                3,
                                4
                            ],
                            "start": "20:00:00",
                            "end": "09:30:00"
                        },
                        {
                            "days": [
                                5,
                                6
                            ],
                            "start": "00:00:00",
                            "end": "23:59:59"
                        }
                    ]
                },
                "suppressAllNotifications": false,
                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                "profileImageIncludingSasToken": null,
                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                "thumbnailProfileImageIncludingSasToken": null,
                "locale": "en-gb",
                "jobTitle": "System Architect",
                "invitePending": false,
                "givenName": "Ian",
                "surname": "Robertson"
            },
            "created": "2024-09-12T13:36:44.795Z",
            "modified": "2024-09-12T13:36:44.795Z",
            "modifiedBy": {
                "userName": "ian.danger.robertson@gmail.com",
                "displayName": "Ian Robertson",
                "id": "6bebd073-a47f-4dba-a6c4-b3178add1b77",
                "apiRoles": [
                    "tenant_Manager",
                    "application_Developer",
                    "user_Basic",
                    "billing_Admin"
                ],
                "companyName": "Russet Properties (Software) Ltd",
                "emailAddress": "ian.danger.robertson@gmail.com",
                "telegramChatId": 5694353874,
                "phoneNumber": "07530086434",
                "unsocialHours": {
                    "doNotDuringRanges": [
                        {
                            "days": [
                                0,
                                1,
                                2,
                                3,
                                4
                            ],
                            "start": "20:00:00",
                            "end": "09:30:00"
                        },
                        {
                            "days": [
                                5,
                                6
                            ],
                            "start": "00:00:00",
                            "end": "23:59:59"
                        }
                    ]
                },
                "suppressAllNotifications": false,
                "profileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profileImage.jpg",
                "profileImageIncludingSasToken": null,
                "thumbnailProfileImage": "6bebd073-a47f-4dba-a6c4-b3178add1b77/profile_thumbnail.jpg",
                "thumbnailProfileImageIncludingSasToken": null,
                "locale": "en-gb",
                "jobTitle": "System Architect",
                "invitePending": false,
                "givenName": "Ian",
                "surname": "Robertson"
            }
        }
    ];

    static templateData = {

        "items": [
            {
                "templateName": "None",
                "default": true,
                "subTasks": [],
                "isInspection": false,
                "id": "66e2ee5bf854ca6e1ba1bade",
                "createdBy": {
                    "userName": "System",
                    "displayName": "System Service Account",
                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                    "apiRoles": [
                        "systemAdmin"
                    ],
                    "companyName": "System",
                    "emailAddress": "not_real@property-manager.com",
                    "telegramChatId": 0,
                    "phoneNumber": null,
                    "unsocialHours": {
                        "doNotDuringRanges": []
                    },
                    "suppressAllNotifications": false,
                    "profileImage": null,
                    "profileImageIncludingSasToken": null,
                    "thumbnailProfileImage": null,
                    "thumbnailProfileImageIncludingSasToken": null,
                    "locale": "en-gb",
                    "jobTitle": null,
                    "invitePending": false,
                    "givenName": null,
                    "surname": null
                },
                "created": "2024-09-12T13:36:27.444Z",
                "modified": "2024-09-12T13:36:27.444Z",
                "modifiedBy": {
                    "userName": "System",
                    "displayName": "System Service Account",
                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                    "apiRoles": [
                        "systemAdmin"
                    ],
                    "companyName": "System",
                    "emailAddress": "not_real@property-manager.com",
                    "telegramChatId": 0,
                    "phoneNumber": null,
                    "unsocialHours": {
                        "doNotDuringRanges": []
                    },
                    "suppressAllNotifications": false,
                    "profileImage": null,
                    "profileImageIncludingSasToken": null,
                    "thumbnailProfileImage": null,
                    "thumbnailProfileImageIncludingSasToken": null,
                    "locale": "en-gb",
                    "jobTitle": null,
                    "invitePending": false,
                    "givenName": null,
                    "surname": null
                }
            },
            {
                "templateName": "Move In",
                "default": false,
                "subTasks": [
                    {
                        "columnName": "backlog",
                        "items": [
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1badf",
                                "title": "Draft Contract",
                                "order": 0,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1bae0",
                                "title": "Initiate Referencing",
                                "order": 0,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1bae1",
                                "title": "Manage Guarantor",
                                "order": 2,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1bae2",
                                "title": "Manage Deposit",
                                "order": 3,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            }
                        ],
                        "displayOrder": 0,
                        "isLastColumn": false,
                        "id": "66e2ee5bf854ca6e1ba1bae5",
                        "createdBy": {
                            "userName": "System",
                            "displayName": "System Service Account",
                            "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                            "apiRoles": [
                                "systemAdmin"
                            ],
                            "companyName": "System",
                            "emailAddress": "not_real@property-manager.com",
                            "telegramChatId": 0,
                            "phoneNumber": null,
                            "unsocialHours": {
                                "doNotDuringRanges": []
                            },
                            "suppressAllNotifications": false,
                            "profileImage": null,
                            "profileImageIncludingSasToken": null,
                            "thumbnailProfileImage": null,
                            "thumbnailProfileImageIncludingSasToken": null,
                            "locale": "en-gb",
                            "jobTitle": null,
                            "invitePending": false,
                            "givenName": null,
                            "surname": null
                        },
                        "created": "2024-09-12T13:36:27.444Z",
                        "modified": "2024-09-12T13:36:27.444Z",
                        "modifiedBy": {
                            "userName": "System",
                            "displayName": "System Service Account",
                            "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                            "apiRoles": [
                                "systemAdmin"
                            ],
                            "companyName": "System",
                            "emailAddress": "not_real@property-manager.com",
                            "telegramChatId": 0,
                            "phoneNumber": null,
                            "unsocialHours": {
                                "doNotDuringRanges": []
                            },
                            "suppressAllNotifications": false,
                            "profileImage": null,
                            "profileImageIncludingSasToken": null,
                            "thumbnailProfileImage": null,
                            "thumbnailProfileImageIncludingSasToken": null,
                            "locale": "en-gb",
                            "jobTitle": null,
                            "invitePending": false,
                            "givenName": null,
                            "surname": null
                        }
                    },
                    {
                        "columnName": "in-progress",
                        "items": [
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1badf",
                                "title": "Draft Contract",
                                "order": 0,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1bae0",
                                "title": "Initiate Referencing",
                                "order": 0,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1bae1",
                                "title": "Manage Guarantor",
                                "order": 2,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1bae2",
                                "title": "Manage Deposit",
                                "order": 3,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1bae3",
                                "title": "** Upload Documents **",
                                "order": 4,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            }
                        ],
                        "displayOrder": 1,
                        "isLastColumn": false,
                        "id": "66e2ee5bf854ca6e1ba1bae6",
                        "createdBy": {
                            "userName": "System",
                            "displayName": "System Service Account",
                            "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                            "apiRoles": [
                                "systemAdmin"
                            ],
                            "companyName": "System",
                            "emailAddress": "not_real@property-manager.com",
                            "telegramChatId": 0,
                            "phoneNumber": null,
                            "unsocialHours": {
                                "doNotDuringRanges": []
                            },
                            "suppressAllNotifications": false,
                            "profileImage": null,
                            "profileImageIncludingSasToken": null,
                            "thumbnailProfileImage": null,
                            "thumbnailProfileImageIncludingSasToken": null,
                            "locale": "en-gb",
                            "jobTitle": null,
                            "invitePending": false,
                            "givenName": null,
                            "surname": null
                        },
                        "created": "2024-09-12T13:36:27.444Z",
                        "modified": "2024-09-12T13:36:27.444Z",
                        "modifiedBy": {
                            "userName": "System",
                            "displayName": "System Service Account",
                            "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                            "apiRoles": [
                                "systemAdmin"
                            ],
                            "companyName": "System",
                            "emailAddress": "not_real@property-manager.com",
                            "telegramChatId": 0,
                            "phoneNumber": null,
                            "unsocialHours": {
                                "doNotDuringRanges": []
                            },
                            "suppressAllNotifications": false,
                            "profileImage": null,
                            "profileImageIncludingSasToken": null,
                            "thumbnailProfileImage": null,
                            "thumbnailProfileImageIncludingSasToken": null,
                            "locale": "en-gb",
                            "jobTitle": null,
                            "invitePending": false,
                            "givenName": null,
                            "surname": null
                        }
                    },
                    {
                        "columnName": "done",
                        "items": [
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1badf",
                                "title": "Draft Contract",
                                "order": 0,
                                "isCompleted": false,
                                "autoComplete": true,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1bae0",
                                "title": "Initiate Referencing",
                                "order": 0,
                                "isCompleted": false,
                                "autoComplete": true,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1bae1",
                                "title": "Manage Guarantor",
                                "order": 2,
                                "isCompleted": false,
                                "autoComplete": true,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1bae2",
                                "title": "Manage Deposit",
                                "order": 3,
                                "isCompleted": false,
                                "autoComplete": true,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1bae3",
                                "title": "** Upload Documents **",
                                "order": 4,
                                "isCompleted": false,
                                "autoComplete": true,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            }
                        ],
                        "displayOrder": 2,
                        "isLastColumn": true,
                        "id": "66e2ee5bf854ca6e1ba1bae7",
                        "createdBy": {
                            "userName": "System",
                            "displayName": "System Service Account",
                            "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                            "apiRoles": [
                                "systemAdmin"
                            ],
                            "companyName": "System",
                            "emailAddress": "not_real@property-manager.com",
                            "telegramChatId": 0,
                            "phoneNumber": null,
                            "unsocialHours": {
                                "doNotDuringRanges": []
                            },
                            "suppressAllNotifications": false,
                            "profileImage": null,
                            "profileImageIncludingSasToken": null,
                            "thumbnailProfileImage": null,
                            "thumbnailProfileImageIncludingSasToken": null,
                            "locale": "en-gb",
                            "jobTitle": null,
                            "invitePending": false,
                            "givenName": null,
                            "surname": null
                        },
                        "created": "2024-09-12T13:36:27.444Z",
                        "modified": "2024-09-12T13:36:27.444Z",
                        "modifiedBy": {
                            "userName": "System",
                            "displayName": "System Service Account",
                            "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                            "apiRoles": [
                                "systemAdmin"
                            ],
                            "companyName": "System",
                            "emailAddress": "not_real@property-manager.com",
                            "telegramChatId": 0,
                            "phoneNumber": null,
                            "unsocialHours": {
                                "doNotDuringRanges": []
                            },
                            "suppressAllNotifications": false,
                            "profileImage": null,
                            "profileImageIncludingSasToken": null,
                            "thumbnailProfileImage": null,
                            "thumbnailProfileImageIncludingSasToken": null,
                            "locale": "en-gb",
                            "jobTitle": null,
                            "invitePending": false,
                            "givenName": null,
                            "surname": null
                        }
                    }
                ],
                "isInspection": false,
                "id": "66e2ee5bf854ca6e1ba1bae4",
                "createdBy": {
                    "userName": "System",
                    "displayName": "System Service Account",
                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                    "apiRoles": [
                        "systemAdmin"
                    ],
                    "companyName": "System",
                    "emailAddress": "not_real@property-manager.com",
                    "telegramChatId": 0,
                    "phoneNumber": null,
                    "unsocialHours": {
                        "doNotDuringRanges": []
                    },
                    "suppressAllNotifications": false,
                    "profileImage": null,
                    "profileImageIncludingSasToken": null,
                    "thumbnailProfileImage": null,
                    "thumbnailProfileImageIncludingSasToken": null,
                    "locale": "en-gb",
                    "jobTitle": null,
                    "invitePending": false,
                    "givenName": null,
                    "surname": null
                },
                "created": "2024-09-12T13:36:27.444Z",
                "modified": "2024-09-12T13:36:27.444Z",
                "modifiedBy": {
                    "userName": "System",
                    "displayName": "System Service Account",
                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                    "apiRoles": [
                        "systemAdmin"
                    ],
                    "companyName": "System",
                    "emailAddress": "not_real@property-manager.com",
                    "telegramChatId": 0,
                    "phoneNumber": null,
                    "unsocialHours": {
                        "doNotDuringRanges": []
                    },
                    "suppressAllNotifications": false,
                    "profileImage": null,
                    "profileImageIncludingSasToken": null,
                    "thumbnailProfileImage": null,
                    "thumbnailProfileImageIncludingSasToken": null,
                    "locale": "en-gb",
                    "jobTitle": null,
                    "invitePending": false,
                    "givenName": null,
                    "surname": null
                }
            },
            {
                "templateName": "Move Out",
                "default": false,
                "subTasks": [
                    {
                        "columnName": "backlog",
                        "items": [
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1baed",
                                "title": "Room Inspection",
                                "order": 0,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1baee",
                                "title": "Manage Deposit",
                                "order": 1,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            }
                        ],
                        "displayOrder": 0,
                        "isLastColumn": false,
                        "id": "66e2ee5bf854ca6e1ba1baf0",
                        "createdBy": {
                            "userName": "System",
                            "displayName": "System Service Account",
                            "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                            "apiRoles": [
                                "systemAdmin"
                            ],
                            "companyName": "System",
                            "emailAddress": "not_real@property-manager.com",
                            "telegramChatId": 0,
                            "phoneNumber": null,
                            "unsocialHours": {
                                "doNotDuringRanges": []
                            },
                            "suppressAllNotifications": false,
                            "profileImage": null,
                            "profileImageIncludingSasToken": null,
                            "thumbnailProfileImage": null,
                            "thumbnailProfileImageIncludingSasToken": null,
                            "locale": "en-gb",
                            "jobTitle": null,
                            "invitePending": false,
                            "givenName": null,
                            "surname": null
                        },
                        "created": "2024-09-12T13:36:27.444Z",
                        "modified": "2024-09-12T13:36:27.444Z",
                        "modifiedBy": {
                            "userName": "System",
                            "displayName": "System Service Account",
                            "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                            "apiRoles": [
                                "systemAdmin"
                            ],
                            "companyName": "System",
                            "emailAddress": "not_real@property-manager.com",
                            "telegramChatId": 0,
                            "phoneNumber": null,
                            "unsocialHours": {
                                "doNotDuringRanges": []
                            },
                            "suppressAllNotifications": false,
                            "profileImage": null,
                            "profileImageIncludingSasToken": null,
                            "thumbnailProfileImage": null,
                            "thumbnailProfileImageIncludingSasToken": null,
                            "locale": "en-gb",
                            "jobTitle": null,
                            "invitePending": false,
                            "givenName": null,
                            "surname": null
                        }
                    },
                    {
                        "columnName": "in-progress",
                        "items": [
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1baed",
                                "title": "Room Inspection",
                                "order": 0,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1baee",
                                "title": "Manage Deposit",
                                "order": 1,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            }
                        ],
                        "displayOrder": 1,
                        "isLastColumn": false,
                        "id": "66e2ee5bf854ca6e1ba1baf1",
                        "createdBy": {
                            "userName": "System",
                            "displayName": "System Service Account",
                            "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                            "apiRoles": [
                                "systemAdmin"
                            ],
                            "companyName": "System",
                            "emailAddress": "not_real@property-manager.com",
                            "telegramChatId": 0,
                            "phoneNumber": null,
                            "unsocialHours": {
                                "doNotDuringRanges": []
                            },
                            "suppressAllNotifications": false,
                            "profileImage": null,
                            "profileImageIncludingSasToken": null,
                            "thumbnailProfileImage": null,
                            "thumbnailProfileImageIncludingSasToken": null,
                            "locale": "en-gb",
                            "jobTitle": null,
                            "invitePending": false,
                            "givenName": null,
                            "surname": null
                        },
                        "created": "2024-09-12T13:36:27.444Z",
                        "modified": "2024-09-12T13:36:27.444Z",
                        "modifiedBy": {
                            "userName": "System",
                            "displayName": "System Service Account",
                            "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                            "apiRoles": [
                                "systemAdmin"
                            ],
                            "companyName": "System",
                            "emailAddress": "not_real@property-manager.com",
                            "telegramChatId": 0,
                            "phoneNumber": null,
                            "unsocialHours": {
                                "doNotDuringRanges": []
                            },
                            "suppressAllNotifications": false,
                            "profileImage": null,
                            "profileImageIncludingSasToken": null,
                            "thumbnailProfileImage": null,
                            "thumbnailProfileImageIncludingSasToken": null,
                            "locale": "en-gb",
                            "jobTitle": null,
                            "invitePending": false,
                            "givenName": null,
                            "surname": null
                        }
                    },
                    {
                        "columnName": "done",
                        "items": [
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1baed",
                                "title": "Room Inspection",
                                "order": 0,
                                "isCompleted": false,
                                "autoComplete": true,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1baee",
                                "title": "Manage Deposit",
                                "order": 1,
                                "isCompleted": false,
                                "autoComplete": true,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            }
                        ],
                        "displayOrder": 2,
                        "isLastColumn": true,
                        "id": "66e2ee5bf854ca6e1ba1baf2",
                        "createdBy": {
                            "userName": "System",
                            "displayName": "System Service Account",
                            "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                            "apiRoles": [
                                "systemAdmin"
                            ],
                            "companyName": "System",
                            "emailAddress": "not_real@property-manager.com",
                            "telegramChatId": 0,
                            "phoneNumber": null,
                            "unsocialHours": {
                                "doNotDuringRanges": []
                            },
                            "suppressAllNotifications": false,
                            "profileImage": null,
                            "profileImageIncludingSasToken": null,
                            "thumbnailProfileImage": null,
                            "thumbnailProfileImageIncludingSasToken": null,
                            "locale": "en-gb",
                            "jobTitle": null,
                            "invitePending": false,
                            "givenName": null,
                            "surname": null
                        },
                        "created": "2024-09-12T13:36:27.444Z",
                        "modified": "2024-09-12T13:36:27.444Z",
                        "modifiedBy": {
                            "userName": "System",
                            "displayName": "System Service Account",
                            "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                            "apiRoles": [
                                "systemAdmin"
                            ],
                            "companyName": "System",
                            "emailAddress": "not_real@property-manager.com",
                            "telegramChatId": 0,
                            "phoneNumber": null,
                            "unsocialHours": {
                                "doNotDuringRanges": []
                            },
                            "suppressAllNotifications": false,
                            "profileImage": null,
                            "profileImageIncludingSasToken": null,
                            "thumbnailProfileImage": null,
                            "thumbnailProfileImageIncludingSasToken": null,
                            "locale": "en-gb",
                            "jobTitle": null,
                            "invitePending": false,
                            "givenName": null,
                            "surname": null
                        }
                    }
                ],
                "isInspection": false,
                "id": "66e2ee5bf854ca6e1ba1baef",
                "createdBy": {
                    "userName": "System",
                    "displayName": "System Service Account",
                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                    "apiRoles": [
                        "systemAdmin"
                    ],
                    "companyName": "System",
                    "emailAddress": "not_real@property-manager.com",
                    "telegramChatId": 0,
                    "phoneNumber": null,
                    "unsocialHours": {
                        "doNotDuringRanges": []
                    },
                    "suppressAllNotifications": false,
                    "profileImage": null,
                    "profileImageIncludingSasToken": null,
                    "thumbnailProfileImage": null,
                    "thumbnailProfileImageIncludingSasToken": null,
                    "locale": "en-gb",
                    "jobTitle": null,
                    "invitePending": false,
                    "givenName": null,
                    "surname": null
                },
                "created": "2024-09-12T13:36:27.444Z",
                "modified": "2024-09-12T13:36:27.444Z",
                "modifiedBy": {
                    "userName": "System",
                    "displayName": "System Service Account",
                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                    "apiRoles": [
                        "systemAdmin"
                    ],
                    "companyName": "System",
                    "emailAddress": "not_real@property-manager.com",
                    "telegramChatId": 0,
                    "phoneNumber": null,
                    "unsocialHours": {
                        "doNotDuringRanges": []
                    },
                    "suppressAllNotifications": false,
                    "profileImage": null,
                    "profileImageIncludingSasToken": null,
                    "thumbnailProfileImage": null,
                    "thumbnailProfileImageIncludingSasToken": null,
                    "locale": "en-gb",
                    "jobTitle": null,
                    "invitePending": false,
                    "givenName": null,
                    "surname": null
                }
            },
            {
                "templateName": "Regular Inspection",
                "default": false,
                "subTasks": [
                    {
                        "columnName": "backlog",
                        "items": [
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1baf5",
                                "title": "Fire Alarm Check",
                                "order": 0,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1baf6",
                                "title": "Bin Check",
                                "order": 1,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1baf7",
                                "title": "Escape Routes Check",
                                "order": 2,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1baf8",
                                "title": "Emergency Lighting Check",
                                "order": 3,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            }
                        ],
                        "displayOrder": 0,
                        "isLastColumn": false,
                        "id": "66e2ee5bf854ca6e1ba1bafa",
                        "createdBy": {
                            "userName": "System",
                            "displayName": "System Service Account",
                            "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                            "apiRoles": [
                                "systemAdmin"
                            ],
                            "companyName": "System",
                            "emailAddress": "not_real@property-manager.com",
                            "telegramChatId": 0,
                            "phoneNumber": null,
                            "unsocialHours": {
                                "doNotDuringRanges": []
                            },
                            "suppressAllNotifications": false,
                            "profileImage": null,
                            "profileImageIncludingSasToken": null,
                            "thumbnailProfileImage": null,
                            "thumbnailProfileImageIncludingSasToken": null,
                            "locale": "en-gb",
                            "jobTitle": null,
                            "invitePending": false,
                            "givenName": null,
                            "surname": null
                        },
                        "created": "2024-09-12T13:36:27.444Z",
                        "modified": "2024-09-12T13:36:27.444Z",
                        "modifiedBy": {
                            "userName": "System",
                            "displayName": "System Service Account",
                            "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                            "apiRoles": [
                                "systemAdmin"
                            ],
                            "companyName": "System",
                            "emailAddress": "not_real@property-manager.com",
                            "telegramChatId": 0,
                            "phoneNumber": null,
                            "unsocialHours": {
                                "doNotDuringRanges": []
                            },
                            "suppressAllNotifications": false,
                            "profileImage": null,
                            "profileImageIncludingSasToken": null,
                            "thumbnailProfileImage": null,
                            "thumbnailProfileImageIncludingSasToken": null,
                            "locale": "en-gb",
                            "jobTitle": null,
                            "invitePending": false,
                            "givenName": null,
                            "surname": null
                        }
                    },
                    {
                        "columnName": "in-progress",
                        "items": [
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1baf5",
                                "title": "Fire Alarm Check",
                                "order": 0,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1baf6",
                                "title": "Bin Check",
                                "order": 1,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1baf7",
                                "title": "Escape Routes Check",
                                "order": 2,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1baf8",
                                "title": "Emergency Lighting Check",
                                "order": 3,
                                "isCompleted": false,
                                "autoComplete": false,
                                "templateItem": true,
                                "checkCompleteStatus": "na"
                            }
                        ],
                        "displayOrder": 1,
                        "isLastColumn": false,
                        "id": "66e2ee5bf854ca6e1ba1bafb",
                        "createdBy": {
                            "userName": "System",
                            "displayName": "System Service Account",
                            "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                            "apiRoles": [
                                "systemAdmin"
                            ],
                            "companyName": "System",
                            "emailAddress": "not_real@property-manager.com",
                            "telegramChatId": 0,
                            "phoneNumber": null,
                            "unsocialHours": {
                                "doNotDuringRanges": []
                            },
                            "suppressAllNotifications": false,
                            "profileImage": null,
                            "profileImageIncludingSasToken": null,
                            "thumbnailProfileImage": null,
                            "thumbnailProfileImageIncludingSasToken": null,
                            "locale": "en-gb",
                            "jobTitle": null,
                            "invitePending": false,
                            "givenName": null,
                            "surname": null
                        },
                        "created": "2024-09-12T13:36:27.444Z",
                        "modified": "2024-09-12T13:36:27.444Z",
                        "modifiedBy": {
                            "userName": "System",
                            "displayName": "System Service Account",
                            "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                            "apiRoles": [
                                "systemAdmin"
                            ],
                            "companyName": "System",
                            "emailAddress": "not_real@property-manager.com",
                            "telegramChatId": 0,
                            "phoneNumber": null,
                            "unsocialHours": {
                                "doNotDuringRanges": []
                            },
                            "suppressAllNotifications": false,
                            "profileImage": null,
                            "profileImageIncludingSasToken": null,
                            "thumbnailProfileImage": null,
                            "thumbnailProfileImageIncludingSasToken": null,
                            "locale": "en-gb",
                            "jobTitle": null,
                            "invitePending": false,
                            "givenName": null,
                            "surname": null
                        }
                    },
                    {
                        "columnName": "done",
                        "items": [
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1baf5",
                                "title": "Fire Alarm Check",
                                "order": 0,
                                "isCompleted": false,
                                "autoComplete": true,
                                "templateItem": true,
                                "checkCompleteStatus": "passed"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1baf6",
                                "title": "Bin Check",
                                "order": 1,
                                "isCompleted": false,
                                "autoComplete": true,
                                "templateItem": true,
                                "checkCompleteStatus": "passed"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1baf7",
                                "title": "Escape Routes Check",
                                "order": 2,
                                "isCompleted": false,
                                "autoComplete": true,
                                "templateItem": true,
                                "checkCompleteStatus": "passed"
                            },
                            {
                                "subTaskId": "66e2ee5bf854ca6e1ba1baf8",
                                "title": "Emergency Lighting Check",
                                "order": 3,
                                "isCompleted": false,
                                "autoComplete": true,
                                "templateItem": true,
                                "checkCompleteStatus": "passed"
                            }
                        ],
                        "displayOrder": 2,
                        "isLastColumn": true,
                        "id": "66e2ee5bf854ca6e1ba1bafc",
                        "createdBy": {
                            "userName": "System",
                            "displayName": "System Service Account",
                            "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                            "apiRoles": [
                                "systemAdmin"
                            ],
                            "companyName": "System",
                            "emailAddress": "not_real@property-manager.com",
                            "telegramChatId": 0,
                            "phoneNumber": null,
                            "unsocialHours": {
                                "doNotDuringRanges": []
                            },
                            "suppressAllNotifications": false,
                            "profileImage": null,
                            "profileImageIncludingSasToken": null,
                            "thumbnailProfileImage": null,
                            "thumbnailProfileImageIncludingSasToken": null,
                            "locale": "en-gb",
                            "jobTitle": null,
                            "invitePending": false,
                            "givenName": null,
                            "surname": null
                        },
                        "created": "2024-09-12T13:36:27.444Z",
                        "modified": "2024-09-12T13:36:27.444Z",
                        "modifiedBy": {
                            "userName": "System",
                            "displayName": "System Service Account",
                            "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                            "apiRoles": [
                                "systemAdmin"
                            ],
                            "companyName": "System",
                            "emailAddress": "not_real@property-manager.com",
                            "telegramChatId": 0,
                            "phoneNumber": null,
                            "unsocialHours": {
                                "doNotDuringRanges": []
                            },
                            "suppressAllNotifications": false,
                            "profileImage": null,
                            "profileImageIncludingSasToken": null,
                            "thumbnailProfileImage": null,
                            "thumbnailProfileImageIncludingSasToken": null,
                            "locale": "en-gb",
                            "jobTitle": null,
                            "invitePending": false,
                            "givenName": null,
                            "surname": null
                        }
                    }
                ],
                "isInspection": true,
                "id": "66e2ee5bf854ca6e1ba1baf9",
                "createdBy": {
                    "userName": "System",
                    "displayName": "System Service Account",
                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                    "apiRoles": [
                        "systemAdmin"
                    ],
                    "companyName": "System",
                    "emailAddress": "not_real@property-manager.com",
                    "telegramChatId": 0,
                    "phoneNumber": null,
                    "unsocialHours": {
                        "doNotDuringRanges": []
                    },
                    "suppressAllNotifications": false,
                    "profileImage": null,
                    "profileImageIncludingSasToken": null,
                    "thumbnailProfileImage": null,
                    "thumbnailProfileImageIncludingSasToken": null,
                    "locale": "en-gb",
                    "jobTitle": null,
                    "invitePending": false,
                    "givenName": null,
                    "surname": null
                },
                "created": "2024-09-12T13:36:27.444Z",
                "modified": "2024-09-12T13:36:27.444Z",
                "modifiedBy": {
                    "userName": "System",
                    "displayName": "System Service Account",
                    "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
                    "apiRoles": [
                        "systemAdmin"
                    ],
                    "companyName": "System",
                    "emailAddress": "not_real@property-manager.com",
                    "telegramChatId": 0,
                    "phoneNumber": null,
                    "unsocialHours": {
                        "doNotDuringRanges": []
                    },
                    "suppressAllNotifications": false,
                    "profileImage": null,
                    "profileImageIncludingSasToken": null,
                    "thumbnailProfileImage": null,
                    "thumbnailProfileImageIncludingSasToken": null,
                    "locale": "en-gb",
                    "jobTitle": null,
                    "invitePending": false,
                    "givenName": null,
                    "surname": null
                }
            }
        ],
        "id": "66e2ee5bf854ca6e1ba1badd",
        "createdBy": {
            "userName": "System",
            "displayName": "System Service Account",
            "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
            "apiRoles": [
                "systemAdmin"
            ],
            "companyName": "System",
            "emailAddress": "not_real@property-manager.com",
            "telegramChatId": 0,
            "phoneNumber": null,
            "unsocialHours": {
                "doNotDuringRanges": []
            },
            "suppressAllNotifications": false,
            "profileImage": null,
            "profileImageIncludingSasToken": null,
            "thumbnailProfileImage": null,
            "thumbnailProfileImageIncludingSasToken": null,
            "locale": "en-gb",
            "jobTitle": null,
            "invitePending": false,
            "givenName": null,
            "surname": null
        },
        "created": "2024-09-12T13:36:27.444Z",
        "modified": "2024-09-12T13:36:27.444Z",
        "modifiedBy": {
            "userName": "System",
            "displayName": "System Service Account",
            "id": "A04D268D-CB01-4F95-81E0-22D197ED68C7",
            "apiRoles": [
                "systemAdmin"
            ],
            "companyName": "System",
            "emailAddress": "not_real@property-manager.com",
            "telegramChatId": 0,
            "phoneNumber": null,
            "unsocialHours": {
                "doNotDuringRanges": []
            },
            "suppressAllNotifications": false,
            "profileImage": null,
            "profileImageIncludingSasToken": null,
            "thumbnailProfileImage": null,
            "thumbnailProfileImageIncludingSasToken": null,
            "locale": "en-gb",
            "jobTitle": null,
            "invitePending": false,
            "givenName": null,
            "surname": null
        }

    };

    static findSubTasks(projectId, pageNumber, itemsPerPage, filterPredicate, sortPredicate, sortDirection) {

        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {

                console.log(`Getting Tasks from Project: ${projectId}`);

                let allSubTasks = _.flatMap(_.flatMap(_.filter(KanbanAPI.projects, t => t.projectId === projectId), p => p.columns), c => c.items) ?? [];

                allSubTasks = _.orderBy(_.filter(allSubTasks, st => filterPredicate(st)), st => sortPredicate(st), sortDirection);

                const totalCount = allSubTasks.length;

                // Example pageNumber = 0, itemsPerPage = 3, I expect items [0], [1], [2]
                // Example pageNumber = 1, itemsPerPage = 3, I expect items [3], [4], [5]
                // Example pageNumber = 2, itemsPerPage = 3, I expect items [6], [7], [8]

                const maxIndex = ((pageNumber + 1) * itemsPerPage);
                const minIndex = maxIndex - (itemsPerPage);

                const pagedTasks = allSubTasks.slice(minIndex, maxIndex);

                const paginationResult = {
                    pagedTasks: pagedTasks,
                    totalCount: totalCount,
                    itemsOnPage: pagedTasks.length
                }

                resolve(assign({}, paginationResult));

            }, delay.value());
        });
    }

    getProjectData = () => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {

                console.log('Getting Projects');

                resolve(assign([], KanbanAPI.projects));

            }, delay.value());
        });
    }

    getProjectsByProperty = (propertyId) => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {

                console.log(`Getting Projects for property: ${propertyId}`);

                const propertyProjects = KanbanAPI.projects.filter(p => p.propertyId === propertyId);
                resolve(assign([], propertyProjects));

            }, delay.value());
        });
    }

    getProject = (projectId) => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {

                console.log(`Getting Project: ${projectId}`);

                const project = _.find(KanbanAPI.projects, p => p.projectId === projectId);

                resolve(assign({}, project));

            }, delay.value());
        });
    }


    static getSingleTileById = (id, projectId) => {

        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {

                console.log(`Getting Task: ${id}`);

                let tile = _.first(_.filter(_.flatMap(_.flatMap(_.filter(KanbanAPI.projects, t => t.projectId === projectId), x => x.columns), d => d.items), item => item.id === id) ?? []);

                resolve(assign({}, tile));

            }, delay.value());
        });
    }

    loadSystemTemplates = () => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {
                console.log('Loading System Templates');
                resolve(assign({}, KanbanAPI.templateData));
            }, delay.value());
        });
    }

    getTemplateData = () => KanbanAPI.templateData;

    static getTemplateData(url) {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {

                console.log('Getting Templates');

                resolve(assign([], KanbanAPI.templateData));

            }, delay.value());
        });
    }

    listenForUpdates = (updateName, subscriberCallback) => {

        const listener = _.find(KanbanAPI.listeners, l => l.name === updateName);
        if (!listener) {
            KanbanAPI.listeners.push({ name: updateName, callback: subscriberCallback });
        }
        else {
            // replace the whole listener...
            const listenerIndex = _.findIndex(KanbanAPI.listeners, l => l.name === updateName);
            KanbanAPI.listeners.splice(listenerIndex, 1); // Remove current version
            KanbanAPI.listeners.splice(listenerIndex, 0, { name: updateName, callback: subscriberCallback }); // Insert new version in its place
        }
    }

    static moveTile(data) {

        const { source, destination, selectedProject, user } = data;

        const project = _.find(this.projects, t => t.projectId === selectedProject.projectId);

        const sourceColumn = _.find(project.columns, t => t.name === source.droppableId);
        const destinationColumn = _.find(project.columns, t => t.name === destination.droppableId);

        const isFinalColumn = _.maxBy(project.columns, c => c.displayOrder).displayOrder === destinationColumn.displayOrder;

        const tileMoved = sourceColumn.items[source.index];

        sourceColumn.items.splice(source.index, 1);
        destinationColumn.items.splice(destination.index, 0, tileMoved);


        if (sourceColumn === destinationColumn) {
            console.log("Source and Destination column are the same. Just reordering...")
        }
        else {

            console.log(`Source '${sourceColumn.name}' >>>`, sourceColumn.items);
            console.log(`Destination '${destinationColumn.name}' >>>`, destinationColumn.items);

            const template = tileMoved.template ? _.find(KanbanAPI.templateData.items, t => t.id === tileMoved.template.id) : null;
            const newTasks = template ? KanbanFunctions.getTasksForColumn(destinationColumn, template) : [];
            KanbanFunctions.addMissingSubTasks(tileMoved.tasks, newTasks);

            const idsToComplete = _.map(_.filter(newTasks, nt => nt.autoComplete), nt => nt.subTaskId);

            if (arrayAny(idsToComplete)) {
                KanbanFunctions.completeAutoCompleteSubTasks(tileMoved.tasks, idsToComplete);
            }

            if (isFinalColumn) {
                tileMoved.completedDate = DateTime.now().toISO();
                tileMoved.completedBy = { name: user.name, userName: user.username };
            }
        }

        const listener = _.find(KanbanAPI.listeners, l => l.name === "columns");

        if (listener) {
            listener.callback(this.projects);
        }

    }

    static addNewTask(project, name, description, createdBy, tileTemplate, tasks) {

        let selectedProject = _.find(this.projects, t => t.projectId === project.projectId);
        let firstColumn = _.find(selectedProject.columns, c => c.displayOrder === 0);

        let count = 0;

        for (const t of tasks) {
            t.complete = false;
        }

        selectedProject.columns.forEach(col => {
            count += col.items.length;
        });

        firstColumn.items = [...firstColumn.items,
        {
            id: `tile-${count + 1}`,
            template: _.omit(tileTemplate, ['subTasks']),
            created: DateTime.now().toISO(),
            createdBy: { name: createdBy.name, userName: createdBy.username },
            name: name,
            description: description,
            tags: [],
            tasks: tasks ?? []
        }];

        const newTasksListener = _.find(KanbanAPI.listeners, l => l.name === "columns");
        if (newTasksListener) {
            newTasksListener.callback(this.projects);
        }
    }

    getSingleTileById = (id) => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {
                console.log(`Getting Task: ${id}`);
                console.log('Available projects:', KanbanAPI.projects.length);
                
                // Search through all projects and columns to find the tile
                let tile = null;
                for (const project of KanbanAPI.projects) {
                    console.log(`Searching project: ${project.name} with ${project.columns.length} columns`);
                    for (const column of project.columns) {
                        console.log(`Searching column: ${column.name} with ${column.items.length} items`);
                        const foundTile = column.items.find(item => {
                            console.log(`Checking item ID: ${item.id} against ${id}`);
                            return item.id === id;
                        });
                        if (foundTile) {
                            console.log('Found tile:', foundTile);
                            tile = foundTile;
                            break;
                        }
                    }
                    if (tile) break;
                }
                
                if (!tile) {
                    console.log('No tile found for ID:', id);
                }
                
                resolve(assign({}, tile));
            }, delay.value());
        });
    }

    upsertTile = (tile) => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {
                console.log("Add or update tile", tile);
                
                // Find and update the tile in the projects
                let updatedProject = null;
                for (const project of KanbanAPI.projects) {
                    for (const column of project.columns) {
                        const tileIndex = column.items.findIndex(item => item.id === tile.id);
                        if (tileIndex !== -1) {
                            // Update the tile
                            column.items[tileIndex] = assign({}, tile);
                            
                            // If destinationColumnId is set, move the tile to that column
                            if (tile.destinationColumnId && tile.destinationColumnId !== column.columnId) {
                                const destinationColumn = project.columns.find(col => col.columnId === tile.destinationColumnId);
                                if (destinationColumn) {
                                    // Remove from current column
                                    const movedTile = column.items.splice(tileIndex, 1)[0];
                                    // Add to destination column at the specified order
                                    destinationColumn.items.splice(tile.order || 0, 0, movedTile);
                                    
                                    // Update column reference
                                    movedTile.columnId = tile.destinationColumnId;
                                    
                                    // Handle completion status based on column
                                    const isLastColumn = _.maxBy(project.columns, c => c.displayOrder).columnId === tile.destinationColumnId;
                                    if (isLastColumn) {
                                        movedTile.completed = tile.completed || new Date().toISOString();
                                        movedTile.status = tile.status || "Closed";
                                    } else {
                                        movedTile.completed = null;
                                        movedTile.status = destinationColumn.name === "In Progress" ? "In Progress" : "Open";
                                    }
                                }
                            }
                            
                            updatedProject = project;
                            break;
                        }
                    }
                    if (updatedProject) break;
                }
                
                // Return the entire project/board like the real API
                resolve(assign({}, updatedProject || KanbanAPI.projects[0]));
            }, delay.value());
        });
    }

    moveTile = async (movedItem) => {
        const board = await this.upsertTile(movedItem);
        return board;
    }

    addProject = (projectName, propertyId = null) => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {
                console.log(`Adding project: ${projectName} for property: ${propertyId}`);
                
                const newProject = {
                    "companyId": "66d74be9d236cf062d9664f2",
                    "propertyId": propertyId,
                    "name": projectName,
                    "columns": [
                        {
                            "columnId": new ObjectID().toHexString(),
                            "displayOrder": 0,
                            "name": "To Do",
                            "itemClasses": null,
                            "items": []
                        },
                        {
                            "columnId": new ObjectID().toHexString(),
                            "displayOrder": 1,
                            "name": "In Progress",
                            "itemClasses": null,
                            "items": []
                        },
                        {
                            "columnId": new ObjectID().toHexString(),
                            "displayOrder": 2,
                            "name": "Done",
                            "itemClasses": null,
                            "items": []
                        }
                    ],
                    "id": new ObjectID().toHexString(),
                    "created": new Date().toISOString(),
                    "modified": new Date().toISOString()
                };
                
                KanbanAPI.projects.push(newProject);
                resolve(assign({}, newProject));
            }, delay.value());
        });
    }

    addNewTask = async (board, name, description, createdBy, tileTemplate, tasks) => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {
                console.log(`Adding new task: ${name}`);
                
                const project = KanbanAPI.projects.find(p => p.id === board.id);
                if (!project) {
                    reject(new Error('Project not found'));
                    return;
                }
                
                const firstColumn = _.minBy(project.columns, c => c.displayOrder);
                let count = 0;
                project.columns.forEach(col => {
                    count += col.items.length;
                });
                
                const newTile = {
                    id: new ObjectID().toHexString(),
                    name: name,
                    description: description,
                    order: count,
                    boardId: board.id,
                    columnId: firstColumn.columnId,
                    templateId: tileTemplate?.id || "66e2ee5bf854ca6e1ba1bade",
                    subTasks: tasks || [],
                    tags: [],
                    completedBy: null,
                    dueDate: null,
                    completed: null,
                    destinationColumnId: null,
                    status: "Open",
                    priority: "Medium",
                    created: new Date().toISOString(),
                    modified: new Date().toISOString()
                };
                
                firstColumn.items.push(newTile);
                resolve(assign({}, project));
            }, delay.value());
        });
    }

    addSubTask = async (project, tileId, newTask) => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {
                console.log(`Adding subtask to tile: ${tileId}`);
                
                const thisProject = KanbanAPI.projects.find(p => p.id === project.id);
                if (!thisProject) {
                    reject(new Error('Project not found'));
                    return;
                }
                
                let tile = null;
                for (const column of thisProject.columns) {
                    tile = column.items.find(t => t.id === tileId);
                    if (tile) break;
                }
                
                if (!tile) {
                    reject(new Error('Tile not found'));
                    return;
                }
                
                newTask.subTaskId = new ObjectID().toHexString();
                newTask.editOn = true;
                newTask.order = tile.subTasks.length;
                newTask.autoComplete = false;
                
                tile.subTasks.push(newTask);
                resolve(assign({}, thisProject));
            }, delay.value());
        });
    }

    deleteSubTask = async (project, tileId, subTask) => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {
                console.log(`Deleting subtask from tile: ${tileId}`);
                
                const thisProject = KanbanAPI.projects.find(p => p.id === project.id);
                if (!thisProject) {
                    reject(new Error('Project not found'));
                    return;
                }
                
                for (const column of thisProject.columns) {
                    for (const tile of column.items) {
                        if (tile.id === tileId) {
                            const index = tile.subTasks.findIndex(t => t.subTaskId === subTask.subTaskId);
                            if (index !== -1) {
                                tile.subTasks.splice(index, 1);
                                resolve(assign({}, thisProject));
                                return;
                            }
                        }
                    }
                }
                
                reject(new Error('Subtask not found'));
            }, delay.value());
        });
    }

    updateSubTask = async (project, tileId, updatedTask) => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {
                console.log(`Updating subtask in tile: ${tileId}`);
                
                const thisProject = KanbanAPI.projects.find(p => p.id === project.id);
                if (!thisProject) {
                    reject(new Error('Project not found'));
                    return;
                }
                
                let tile = null;
                for (const column of thisProject.columns) {
                    tile = column.items.find(t => t.id === tileId);
                    if (tile) break;
                }
                
                if (!tile) {
                    reject(new Error('Tile not found'));
                    return;
                }
                
                const originalTaskIndex = tile.subTasks.findIndex(st => st.subTaskId === updatedTask.subTaskId);
                if (originalTaskIndex !== -1) {
                    tile.subTasks.splice(originalTaskIndex, 1, updatedTask);
                    resolve(assign({}, thisProject));
                } else {
                    reject(new Error('Subtask not found'));
                }
            }, delay.value());
        });
    }

    getMaintenanceCount = () => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {
                // Count maintenance items from all projects (To Do and In Progress columns)
                let maintenanceCount = 0;
                
                KanbanAPI.projects.forEach(project => {
                    project.columns.forEach(column => {
                        // Only count items in To Do and In Progress columns (not Done)
                        if (column.name !== 'Done') {
                            maintenanceCount += column.items.length;
                        }
                    });
                });
                
                resolve(maintenanceCount.toString());
            }, delay.value());
        });
    }

    updateBoard = (board) => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {
                console.log(`Updating board: ${board.id}`);
                
                const projectIndex = KanbanAPI.projects.findIndex(p => p.id === board.id);
                if (projectIndex !== -1) {
                    KanbanAPI.projects[projectIndex] = assign({}, board);
                    resolve(assign({}, board));
                } else {
                    reject(new Error('Board not found'));
                }
            }, delay.value());
        });
    }

    moveColumn = async (board, column, direction) => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {
                console.log(`Moving column ${column.columnId} ${direction}`);
                
                const thisBoard = KanbanAPI.projects.find(p => p.id === board.id);
                if (!thisBoard) {
                    reject(new Error('Board not found'));
                    return;
                }
                
                const thisColumn = thisBoard.columns.find(c => c.columnId === column.columnId);
                if (!thisColumn) {
                    reject(new Error('Column not found'));
                    return;
                }
                
                let positionToSwitchWith = -1;
                let columnToSwitchWith = null;
                
                switch (direction) {
                    case "left":
                        positionToSwitchWith = thisColumn.displayOrder - 1;
                        columnToSwitchWith = thisBoard.columns.find(c => c.displayOrder === positionToSwitchWith);
                        if (columnToSwitchWith) {
                            columnToSwitchWith.displayOrder += 1;
                            thisColumn.displayOrder -= 1;
                        }
                        break;
                    case "right":
                    default:
                        positionToSwitchWith = thisColumn.displayOrder + 1;
                        columnToSwitchWith = thisBoard.columns.find(c => c.displayOrder === positionToSwitchWith);
                        if (columnToSwitchWith) {
                            columnToSwitchWith.displayOrder -= 1;
                            thisColumn.displayOrder += 1;
                        }
                }
                
                thisBoard.columns = _.orderBy(thisBoard.columns, c => c.displayOrder, ['asc']);
                thisBoard.columns.forEach((col, i) => {
                    col.displayOrder = i;
                });
                
                resolve(assign({}, thisBoard));
            }, delay.value());
        });
    }

    addColumnToProject = async (board, newColumnName) => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {
                console.log(`Adding column ${newColumnName} to board`);
                
                const thisBoard = KanbanAPI.projects.find(p => p.id === board.id);
                if (!thisBoard) {
                    reject(new Error('Board not found'));
                    return;
                }
                
                const newColumn = {
                    columnId: new ObjectID().toHexString(),
                    displayOrder: thisBoard.columns.length,
                    name: newColumnName,
                    itemClasses: null,
                    items: []
                };
                
                thisBoard.columns.push(newColumn);
                resolve(assign({}, thisBoard));
            }, delay.value());
        });
    }

    deleteColumn = async (board, column) => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {
                console.log(`Deleting column ${column.columnId}`);
                
                const thisBoard = KanbanAPI.projects.find(p => p.id === board.id);
                if (!thisBoard) {
                    reject(new Error('Board not found'));
                    return;
                }
                
                const columnToDelete = thisBoard.columns.find(c => c.columnId === column.columnId);
                if (!columnToDelete) {
                    reject(new Error('Column not found'));
                    return;
                }
                
                const previousColumn = thisBoard.columns.find(c => c.displayOrder === Math.max(0, columnToDelete.displayOrder - 1));
                
                // Move all items from deleted column to previous column
                if (previousColumn) {
                    columnToDelete.items.forEach(tile => {
                        tile.columnId = previousColumn.columnId;
                        previousColumn.items.push(tile);
                    });
                }
                
                thisBoard.columns = thisBoard.columns.filter(c => c.columnId !== columnToDelete.columnId);
                
                // Reorder columns
                thisBoard.columns.forEach((col, i) => {
                    col.displayOrder = i;
                });
                
                resolve(assign({}, thisBoard));
            }, delay.value());
        });
    }

    deleteTiles = (tiles) => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {
                console.log(`Deleting ${tiles.length} tiles`);
                
                let updatedBoard = null;
                
                for (const tile of tiles) {
                    for (const project of KanbanAPI.projects) {
                        for (const column of project.columns) {
                            const tileIndex = column.items.findIndex(item => item.id === tile.id);
                            if (tileIndex !== -1) {
                                column.items.splice(tileIndex, 1);
                                updatedBoard = project;
                                break;
                            }
                        }
                        if (updatedBoard) break;
                    }
                }
                
                resolve(assign({}, updatedBoard || KanbanAPI.projects[0]));
            }, delay.value());
        });
    }

    getTemplateData = () => {
        return KanbanAPI.templateData;
    }

    findSubTasks = async (boardId, pageNumber, itemsPerPage, filterPredicate, sortPredicate, sortDirection) => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {
                console.log(`Finding subtasks for board: ${boardId}`);
                
                const board = KanbanAPI.projects.find(p => p.id === boardId);
                if (!board) {
                    resolve(null);
                    return;
                }
                
                const finalColumnItems = _.maxBy(board.columns, c => c.displayOrder).items;
                const allSubTasks = _.orderBy(finalColumnItems.filter(tile => filterPredicate(tile)), tile => sortPredicate(tile), sortDirection);
                
                const totalCount = allSubTasks.length;
                const maxIndex = ((pageNumber + 1) * itemsPerPage);
                const minIndex = maxIndex - itemsPerPage;
                const pagedTasks = allSubTasks.slice(minIndex, maxIndex);
                
                const paginationResult = {
                    pagedTasks: pagedTasks,
                    totalCount: totalCount,
                    itemsOnPage: pagedTasks.length
                };
                
                resolve(paginationResult);
            }, delay.value());
        });
    }

    static upsertTile(tile) {
        console.log("Add or update tile");

        const newTasksListener = _.find(KanbanAPI.listeners, l => l.name === "columns");
        if (newTasksListener) {
            newTasksListener.callback(this.projects);
        }
    }

    static addSubTask(project, tileId, newTask) {

        const thisProject = _.find(this.projects, t => t.projectId === project.projectId);

        let tile = _.find(_.flatMap(thisProject.columns, t => t.items), t => t.id === tileId);

        newTask.id = newTask.id ?? KanbanFunctions.getRandomId();;
        newTask.editOn = true;

        tile.tasks.push(newTask);

        const newTasksListener = _.find(KanbanAPI.listeners, l => l.name === "columns");
        if (newTasksListener) {
            newTasksListener.callback(this.projects);
        }
    }

    static findSubTaskById(project, tileId, subTaskId) {

        const thisProject = _.find(this.projects, t => t.projectId === project.projectId);

        for (const col of thisProject.columns) {
            for (const tile of col.items) {
                if (tile.id === tileId) {
                    for (const subTask of tile.tasks) {
                        if (subTask.id === subTaskId) {
                            return subTask;
                        }
                    }
                }
            }
        }
        return null;
    }

    // static toggleSubTaskComplete(project, tileId, subTaskId) {

    //     const subTask = this.findSubTaskById(project, tileId, subTaskId);
    //     subTask.complete = !subTask.complete;

    //     const newTasksListener = _.find(KanbanAPI.listeners, l => l.name === "columns");
    //     if (newTasksListener) {
    //         newTasksListener.callback(this.projects);
    //     }
    // }

    // static setSubTaskCheckCompleteStatus(project, tileId, subTaskId, status) {

    //     const subTask = this.findSubTaskById(project, tileId, subTaskId);
    //     subTask.checkCompleteStatus = status;
    //     //console.log("Check Status", subTaskId, status);

    //     const newTasksListener = _.find(KanbanAPI.listeners, l => l.name === "columns");
    //     if (newTasksListener) {
    //         newTasksListener.callback(this.projects);
    //     }
    // }

    static deleteSubTask(project, tileId, subTask) {

        const thisProject = _.find(this.projects, t => t.projectId === project.projectId);

        for (const col of thisProject.columns) {
            for (const tile of col.items) {
                if (tile.id === tileId) {
                    for (const st of tile.tasks) {
                        if (subTask.id === st.id) {
                            let index = tile.tasks.indexOf(st);
                            tile.tasks.splice(index, 1); // Remove current version
                            return;
                        }
                    }
                }
            }
        }

        const newTasksListener = _.find(KanbanAPI.listeners, l => l.name === "columns");
        if (newTasksListener) {
            newTasksListener.callback(this.projects);
        }

    }

    static upsertTask(task) {

        console.log('Upsert sub-task into persistance store...');

        const newTasksListener = _.find(KanbanAPI.listeners, l => l.name === "columns");
        if (newTasksListener) {
            newTasksListener.callback(this.projects);
        }
    }

    static addColumnToProject(projectToEdit, columnName) {

        const project = _.first(_.filter(this.projects, t => t.projectId === projectToEdit.projectId));
        const columnId = _.join(columnName.toLowerCase().split(" "), "-");

        let displayOrder = _.maxBy(project.columns, c => c.displayOrder).displayOrder ?? 0;
        displayOrder = project.columns.length === 0 ? 0 : displayOrder + 1;

        const newColumn = {
            id: columnId,
            name: columnName,
            displayOrder: displayOrder,
            itemClasses: "",
            items: []
        }

        project.columns.push(newColumn);

        const projectIndex = _.findIndex(this.projects, d => d.projectId === projectToEdit.projectId);
        this.projects.splice(projectIndex, 1); // Remove current version
        this.projects.splice(projectIndex, 0, project); // Insert new version in its place

        const newTasksListener = _.find(KanbanAPI.listeners, l => l.name === "columns");
        if (newTasksListener) {
            newTasksListener.callback(this.projects);
        }
    }

    static moveColumn(projectToEdit, column, direction) {

        const project = _.find(this.projects, d => d.projectId === projectToEdit.projectId);

        let positionToSwitchWith = -1;
        let columnToSwitchWith = null;

        switch (direction) {
            case "left":
                positionToSwitchWith = column.displayOrder - 1;
                columnToSwitchWith = _.find(project.columns, c => c.displayOrder === positionToSwitchWith);

                columnToSwitchWith.displayOrder += 1;
                column.displayOrder -= 1;
                break;
            case "right":
            default:
                positionToSwitchWith = column.displayOrder + 1;
                columnToSwitchWith = _.find(project.columns, c => c.displayOrder === positionToSwitchWith);

                columnToSwitchWith.displayOrder -= 1;
                column.displayOrder += 1;
        }

        project.columns = KanbanFunctions.projectColumnsInOrder(this.projects, project.projectId);

        // replace the whole project...
        const projectIndex = _.findIndex(this.projects, d => d.projectId === project.projectId);
        this.projects.splice(projectIndex, 1); // Remove current version
        this.projects.splice(projectIndex, 0, project); // Insert new version in its place

        const listener = _.find(KanbanAPI.listeners, l => l.name === "columns");

        if (listener) {
            listener.callback(this.projects);
        }
    }

    static addProject(projectName) {

        const newProject = {
            projectId: new ObjectID().toHexString(),
            project: projectName,
            columns: [{
                id: "backlog",
                name: "backlog",
                displayOrder: 0,
                itemClasses: "",
                items: []
            },
            {
                id: "in-progress",
                name: "In Progress",
                displayOrder: 1,
                itemClasses: "",
                items: []
            },
            {
                id: "completed",
                name: "Completed",
                displayOrder: 2,
                itemClasses: "",
                items: []
            }]
        }

        this.projects.push(newProject);

        const newProjectListener = _.find(KanbanAPI.listeners, l => l.name === "newProject");
        if (newProjectListener) {
            newProjectListener.callback(newProject);
        }

        const newTasksListener = _.find(KanbanAPI.listeners, l => l.name === "columns");
        if (newTasksListener) {
            newTasksListener.callback(this.projects);
        }

    }

    static deleteColumn(project, column) {

        if (column.displayOrder === 0) { return; } // Don't delete first column. We need somewhere for tasks to go when we delete a column

        const thisProject = _.find(this.projects, t => t.projectId === project.projectId);
        const firstColumn = _.minBy(thisProject.columns, c => c.displayOrder);
        const index = _.findIndex(thisProject.columns, c => c.displayOrder === column.displayOrder);
        const tasksToMove = column.items;

        firstColumn.items = [].concat(firstColumn.items, tasksToMove);

        thisProject.columns.splice(index, 1); // Remove column

        const listener = _.find(KanbanAPI.listeners, l => l.name === "columns");

        if (listener) {
            listener.callback(this.projects);
        }
    }

    static deleteTiles(project, tiles) {

        if (project && arrayAny(tiles)) {
            const thisProject = _.find(this.projects, t => t.projectId === project.projectId);

            for (const tile of tiles) {

                for (const column of thisProject.columns) {
                    const indexWithinColumn = _.findIndex(column.items, i => i.id === tile.id)
                    if (indexWithinColumn > -1) {
                        column.items.splice(indexWithinColumn, 1); // Remove tile
                        break;
                    }
                }
            }

            const listener = _.find(KanbanAPI.listeners, l => l.name === "columns");

            if (listener) {
                listener.callback(this.projects);
            }
        }
    }

}

export default KanbanAPI;